// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function useSidebar(param) {
  var match = React.useState(function () {
        return /* BasicDetails */0;
      });
  return [
          match[0],
          match[1]
        ];
}

var consentTabsList = [
  /* BasicDetails */0,
  /* NotificationSettings */1
];

var tabsList = [/* BasicDetails */0];

function toString(tab) {
  if (tab) {
    return "Notification Settings";
  } else {
    return "Basic Details";
  }
}

function fromString(label) {
  if (label === "Notification Settings") {
    return /* NotificationSettings */1;
  } else {
    return /* BasicDetails */0;
  }
}

export {
  useSidebar ,
  consentTabsList ,
  tabsList ,
  toString ,
  fromString ,
  
}
/* react Not a pure module */
